/**
 * Field names attached by flame utilities to each datapoint before handing the
 * row to XYChart. Kept as constants so accessors passed to XYChart and reads
 * inside tooltips stay in lockstep.
 */

/** Depth of the frame in the call tree (root = 0). */
export const DEPTH_FIELD = 'depth';

/** Index into the original `data` array; used to route tooltip actions back to the caller's row. */
export const FLAME_ORIGINAL_IDX = '__flameOriginalIdx';

/** Derived span duration: `endAccessor - startAccessor`. */
export const VALUE_FIELD = '__value';

/** Normalized start: `startAccessor - minTime`. */
export const START_FIELD = '__start';

/** Normalized end: `endAccessor - minTime`. */
export const END_FIELD = '__end';

/** Number of direct children of a node in the aggregated flame graph. */
export const CHILDREN_COUNT_FIELD = 'childrenCount';

export const XY_DEFAULTS = {
  x0Accessor: 'x0',
  x1Accessor: 'x1',
  xAxisId: 'flame-x-axis',
  yAxisId: 'flame-y-axis',
} as const;

export const DISPLAY_NAME_FLAME_CHART = 'FlameChart';
export const DISPLAY_NAME_FLAME_GRAPH = 'FlameGraph';
